import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid
} from '@mui/material';

const DonatePage = () => {
  return (
    <Container maxWidth="md" sx={{ mb: 6 }}>
      {/* Основная информация */}
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
            Поддержать проект 👍
          </Typography>
          <Typography paragraph>
            Научно доказано что если обучение оплачено, то знания усваиваются в 5 раз быстрее! 😉
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
            Дальнейшие цели:
          </Typography>
          <ul style={{ paddingLeft: '20px' }}>
            <li><Typography>📖 Практика чтения с аудио 🗣️ (✅ реализовано)</Typography></li>
            <li><Typography>🔊 Аудио произношение слов 🗣️ (✅ реализовано v2 с выбором голосов)</Typography></li>
            <li><Typography>📚 Добавить другие языки для изучения</Typography></li>
            <li><Typography>🪪 Сделать персональные аккаунты с возможностью создавать свои таблицы</Typography></li>
            <li><Typography>🔥 Ваши варианты от 200€ 😉</Typography></li>
          </ul>
          
          <Typography paragraph sx={{ mt: 2 }}>
            Но вы же понимаете, жена художница 👩🎨, трое детей 🧒🧒👶, управление B&B 🛋️, стройка 🇮🇹 👷, развитие винного стартапа 🍷💼. 
            То что эти карточки появились – это уже подвиг 😂, поэтому для развития нужна небольшая ваша благодарность 💶.
          </Typography>
          
          <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
            Спасибо 🤗 от чистого сердца ❤️ из Италии 🇮🇹
          </Typography>
        </CardContent>
      </Card>

      {/* Тиньков */}
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
            На карту Тиньков (карты РФ)
          </Typography>
          <Typography paragraph>
            Если вы из России, перевод на карту будет проще всего. По клику откроется удобное окошко.
          </Typography>
          <Typography variant="body2" paragraph>
            Либо по номеру карты: <strong>5536914011005836</strong>
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button 
              variant="contained" 
              size="large" 
              href="https://www.tinkoff.ru/rm/shestakov.boris8/u4fIy79873" 
              target="_blank"
              rel="noopener"
              sx={{ mt: 2 }}
            >
              💳 Донатить
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Revolut / IBAN */}
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
            Revolut / IBAN
          </Typography>
          <Typography paragraph>
            Если удобнее переводом в евро, можно скинуть на Revolut по тегу <strong>@borisshestakov</strong>.
          </Typography>
          <Typography paragraph>
            Или по IBAN: <strong>LT95 3250 0118 4684 9404</strong>
          </Typography>
          <Typography variant="body2">
            Получатель: <strong>Boris Shestakov</strong>
          </Typography>
        </CardContent>
      </Card>

      {/* PayPal */}
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
            PayPal
          </Typography>
          <Typography paragraph>
            Вариант для живущих заграницей и просто у кого там завалялась мелочь на аккаунте.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button 
              variant="contained" 
              size="large" 
              href="https://paypal.me/shestakovboris" 
              target="_blank"
              rel="noopener"
              sx={{ mt: 2 }}
            >
              💰 PayPal.me
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Криптовалюта */}
      <Card>
        <CardContent>
          <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
            Криптовалюта
          </Typography>
          <Grid container spacing={3}>
            {/* Биткоин */}
            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Биткоин</Typography>
                <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                  bc1q8rpd5kqqvf7rddxlq9w0874h5wxp9dl5z77j5w
                </Typography>
                <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                  Отправляйте только Bitcoin (ВТС) на этот адрес.
                </Typography>
              </Box>
            </Grid>

            {/* Toncoin */}
            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Toncoin (TON)</Typography>
                <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                  UQB-1jqG4P9-LMfNZk_q6TuDn-4hpZTfnNNviBWunI6F-yc9
                </Typography>
                <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                  Отправляйте только Toncoin (TON) на этот адрес.
                </Typography>
              </Box>
            </Grid>

            {/* USDT */}
            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>USDT</Typography>
                <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                  TUbcYLsVDPZn3WGr6unih19By1onge3yz5
                </Typography>
                <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                  Отправляйте только USDT TRC20 на этот адрес.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
};

export default DonatePage;
